import { render } from "./LoginMain.vue?vue&type=template&id=344daade"
import script from "./LoginMain.vue?vue&type=script&lang=js"
export * from "./LoginMain.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__